import React, { Component } from "react";

class Tabs extends Component {
  render() {
    return (
      <div className="tabs">
        <div className="tab active">Package with Flights</div>
        <div className="tab">Package without Flights</div>
      </div>
    );
  }
}

export default Tabs;
